/**
 * @generated SignedSource<<71c1334c64cdc3da499f9277d58fafc3>>
 * @relayHash fcff0f9000a441b858dcd9b6bfddd1d2
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fcff0f9000a441b858dcd9b6bfddd1d2

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Aim = "ANALGESIA_ANTI_INFLAMMATORY_TREATMENT" | "DECONGESTION" | "FUNCTIONAL_BANDAGE_TAPE" | "IMPROVEMENT_OF_CARDIO_PULMO_FUNCTION" | "IMPROVEMENT_OF_JOINT_FUNCTION" | "IMPROVEMENT_OF_MOBILITY" | "IMPROVEMENT_OF_MUSCLE_FUNCTION" | "INSTRUCTION" | "PROPRIOCEPTION_COORDINATION";
export type ConditionStage = "ACUTE" | "CHRONIC" | "SUBACUTE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type Occurrence = "FIRST_OCCURRENCE" | "RECURRENCE";
export type PrescriptionRepetition = "FIRST" | "FOURTH" | "SECOND" | "THIRD";
export type ReasonForPhysiotherapy = "ACCIDENT" | "IVMV" | "SICKNESS";
export type Side = "LEFT" | "RIGHT";
export type TreatmentUnitPerDay = "ONCE" | "TWICE";
export type Ch_createPhysiotherapyPrescriptionInput = {
  aims: ReadonlyArray<Aim>;
  allergies: ReadonlyArray<string>;
  conditionStage: ConditionStage;
  conditions: ReadonlyArray<string>;
  diagnosisCode: string;
  duration?: string | null;
  healthcareProviderId?: string | null;
  internalNote?: string | null;
  isHomeTreatment: boolean;
  language: Language;
  leadingSymptom?: string | null;
  medicationIds: ReadonlyArray<string>;
  occurrence: Occurrence;
  patientId: string;
  prescriptionRepetition: PrescriptionRepetition;
  progressNoteId: string;
  reason: ReasonForPhysiotherapy;
  sides?: ReadonlyArray<Side> | null;
  treatmentUnit: number;
  treatmentUnitPerDay: TreatmentUnitPerDay;
  trigger?: string | null;
};
export type useChCreatePhysiotherapyMutation$variables = {
  input: Ch_createPhysiotherapyPrescriptionInput;
};
export type useChCreatePhysiotherapyMutation$data = {
  readonly ch_createPhysiotherapyPrescription: {
    readonly ch_PhysiotherapyPrescription: {
      readonly healthcareProviderId: string | null;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"chPhysiotherapyFragment">;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useChCreatePhysiotherapyMutation = {
  response: useChCreatePhysiotherapyMutation$data;
  variables: useChCreatePhysiotherapyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "healthcareProviderId",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChCreatePhysiotherapyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createPhysiotherapyPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_createPhysiotherapyPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_PhysiotherapyPrescription",
            "kind": "LinkedField",
            "name": "ch_PhysiotherapyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "chPhysiotherapyFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChCreatePhysiotherapyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createPhysiotherapyPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_createPhysiotherapyPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_PhysiotherapyPrescription",
            "kind": "LinkedField",
            "name": "ch_PhysiotherapyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "patientId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aims",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allergies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "conditions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "medicationIds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "conditionStage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "diagnosisCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "duration",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "internalNote",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "leadingSymptom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "prescriptionRepetition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "progressNoteId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sides",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "treatmentUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "trigger",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "treatmentUnitPerDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isHomeTreatment",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "occurrence",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DocumentFileMetadata",
                "kind": "LinkedField",
                "name": "fileMetadata",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "extension",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lengthInKilobytes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "fcff0f9000a441b858dcd9b6bfddd1d2",
    "metadata": {},
    "name": "useChCreatePhysiotherapyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5646125c8f4ff105da8e830e4c6d4aa4";

export default node;
